var React = require('react');

function Cactus (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M224 144a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm64 224a16 16 0 1 0 16 16 16 16 0 0 0-16-16zm176-144a48 48 0 0 0-48 48v64a16 16 0 0 1-16 16h-48v96h48a112.14 112.14 0 0 0 112-112v-64a48 48 0 0 0-48-48zM96 208v-64a48 48 0 0 0-96 0v64a112.14 112.14 0 0 0 112 112h48v-96h-48a16 16 0 0 1-16-16z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M352 96a96 96 0 0 0-192 0v416h192zm-128 80a16 16 0 1 1 16-16 16 16 0 0 1-16 16zm64 224a16 16 0 1 1 16-16 16 16 0 0 1-16 16z","className":"fa-primary","key":2})]);
}

Cactus.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Cactus;

Cactus.default = Cactus;
